import createAxios from "./axiosHttpMarconi";
export const clienteExcluidoService = {
  nuevoClienteExcluido,
  getAllClientesExcluidos,
  eliminarClienteExcluido,
};
function eliminarClienteExcluido(id_excluido) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/clientes-excluidos/${id_excluido}`;
  return axios.delete(urlPath);
}

function nuevoClienteExcluido(data) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/clientes-excluidos`;
  return axios.post(urlPath, data);
}

function getAllClientesExcluidos(pagination, filters) {
  const axios = createAxios();
  const user = JSON.parse(localStorage.getItem("user"));
  let urlPath = `franquiciadora/${user.extraData.franquiciadoraId}/clientes-excluidos`;
  if (pagination) {
    urlPath += `?page=${pagination.currentPage - 1}&limit=${
      pagination.perPage
    }`;
  } else {
    urlPath += "?page=0&limit=10";
  }
  urlPath += getFilters(filters);
  urlPath += "&sort=desde&order=descending";
  return axios.get(urlPath);
}

function getFilters(filters) {
  let urlPath = "";
  if (filters && filters.cliente) {
    urlPath += `&cliente=${filters.cliente}`;
  }
  return urlPath;
}
